module.exports = __webpack_public_path__ + "static/img/md5_red.4b6c3092.svg";